const MAREVA_ACCEPTED = new Set([
  'ACCEPTE',
  'ACCEPTED',
  'ACCEPTEE',
  'VALIDE',
  'VALIDATED',
  'CLEARED',
])

const MAREVA_PROCESSING = new Set([
  'EN_COURS',
  'EN COURS',
  'PENDING',
  'PROCESSING',
  'IN_PROGRESS',
  'SOUMIS',
  'SUBMITTED',
  'EN_ATTENTE',
])

const MAREVA_REJECTED = new Set([
  'REJETE',
  'REJECTED',
  'REFUSE',
  'REFUSED',
  'ERREUR',
  'ERROR',
  'INVALIDE',
])

export type MarevaBusinessStatus = 'accepted' | 'processing' | 'rejected' | 'unknown'

export const mapMarevaRemoteState = (
  state: string | null | undefined
): MarevaBusinessStatus => {
  if (!state) {
    return 'unknown'
  }
  const normalized = state.trim().toUpperCase()
  if (MAREVA_ACCEPTED.has(normalized)) {
    return 'accepted'
  }
  if (MAREVA_PROCESSING.has(normalized)) {
    return 'processing'
  }
  if (MAREVA_REJECTED.has(normalized)) {
    return 'rejected'
  }
  return 'unknown'
}
